import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteFavoriteMeal } from '../../../api/diary-service';
import refetchDiaryAndEnergy from '../../../services/refetch-queries';

const useDeleteFavoriteMeal = (currentDay) => {
    const [isDeleting, setIsDeleting] = useState(false);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: deleteFavoriteMeal,
        onError: (error) => console.error('Failed to delete favorite meal:', error)
    });

    const deleteFavoriteMealAndSync = async (favoriteId) => {
        if (!favoriteId) return;

        setIsDeleting(true);

        // Optimistically update diary cache
        queryClient.setQueryData(['diary', currentDay], (old) => {
            if (!old) return old;

            const updatedMeals = Object.fromEntries(
                Object.entries(old.meals).map(([type, meals]) => [
                    type,
                    meals.map((meal) =>
                        meal.favorite_id === favoriteId
                            ? {
                                  ...meal,
                                  favorite_id: null,
                                  name: ''
                              }
                            : meal
                    )
                ])
            );

            return {
                ...old,
                meals: updatedMeals
            };
        });

        try {
            await mutation.mutateAsync(favoriteId);
            await refetchDiaryAndEnergy(queryClient, currentDay);
        } catch (error) {
            console.error('Delete favorite and sync failed:', error);
        } finally {
            setIsDeleting(false);
        }
    };

    return {
        deleteFavoriteMeal: deleteFavoriteMealAndSync,
        isDeletingFavorite: isDeleting
    };
};

export default useDeleteFavoriteMeal;
